import { action, makeObservable, observable, reaction } from 'mobx';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import { IBillingSystemCompanySelectItem, IBillingSystemOrdersListItemAPI, IFilterParams } from '../interfaces';
import { getBillingSystemOrdersList } from '../middleware';
import { apiParamsCleaner } from '../instruments';

export class BillingSystemStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime,
            () => {
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterParams);
                getBillingSystemOrdersList(cleanParams).then();
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: BillingSystemStore;
    public static getInstance(): BillingSystemStore {
        if (!BillingSystemStore.instance) {
            BillingSystemStore.instance = new BillingSystemStore();
        }
        return BillingSystemStore.instance;
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    @observable ordersList: IBillingSystemOrdersListItemAPI[] = [];
    @action setOrdersList(data: any[]): void {
        this.ordersList = data;
    }

    @observable select: IBillingSystemCompanySelectItem[] = [];
    @action setCompaniesSelect(select: IBillingSystemCompanySelectItem[]): void {
        this.select = select;
    }

    @observable filterParams: IFilterParams = {
        companyId: true,
        dateRange: true,
        pageNumber: true,
        pageSize: true,
        search: true,
    };

    @action cleanStore(): void {
        this.ordersList = [];
        this.select = [];
    }
}
